import { createModel } from '@rematch/core';
import { Customer } from '../dto/Customer.dto';
import { getCustomerInfo as getCustomerInfoService } from '../services/customer';
import type { RootModel } from './index';

export const customer = createModel<RootModel>()({
  state: {} as Customer,
  reducers: {
    getCustomer: (state: Customer) => state,
    setCustomer: (state: Customer, payload: Record<string, any>) =>
      ({ ...state, ...payload } as Customer),
  },
  effects: (dispatch) => ({
    async getCustomerInfo(): Promise<Customer> {
      const res = await getCustomerInfoService();
      dispatch.customer.setCustomer(res);
      return res;
    },
    updateCustomerInfo(fields: Record<string, any>): void {
      dispatch.customer.setCustomer(fields);
    },
  }),
});
